'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error when the component mounts, but don't show any UI
    console.error(error, {
      component: 'GlobalError',
      digest: error.digest,
      url: typeof window !== 'undefined' ? window.location.href : '',
      timestamp: new Date().toISOString(),
    });
  }, [error]);

  // Return a completely transparent error div instead of html/body structure
  return (
    <div 
      style={{ 
        background: 'transparent', 
        pointerEvents: 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999
      }}
    >
      {/* No content rendered for complete transparency */}
    </div>
  );
} 